import { useTranslation } from "react-i18next";
import {
	FrontendUserInfo,
	FrontendProductOrder,
} from "node-library/dist/portal";
import ViewOrdersTable from "./viewOrdersTable";
import { NeutralColor } from "node-library/dist/colors";
import AddIcon from "@mui/icons-material/Add";
import { BlueButton } from "../../../common-components/button";
import { OrderStatus } from "node-library/dist/constants";

interface Props {
	orders: Array<FrontendProductOrder>;
	user: FrontendUserInfo | undefined;
	statusFilterOption: OrderStatus | "";
	goToAddNewOrder: () => void;
	goToViewOrderDetails: (order: FrontendProductOrder) => void;
	discardUnstartedOrder: (order: FrontendProductOrder) => void;
	goToEditOrderPage: (order: FrontendProductOrder) => void;
	viewOrderCOC: (order: FrontendProductOrder) => void;
	viewResult: (order: FrontendProductOrder) => void;

	setDiscardOrderConfirmOpen: React.Dispatch<React.SetStateAction<boolean>>;
	setProceedAction: React.Dispatch<React.SetStateAction<() => void>>;
}

export default function OrderHistoryContent(props: Props) {
	const { t: translation } = useTranslation();

	const {
		orders,
		statusFilterOption,
		goToAddNewOrder,
		goToViewOrderDetails,
		discardUnstartedOrder,
		goToEditOrderPage,
		setDiscardOrderConfirmOpen,
		viewOrderCOC,
		viewResult,
		setProceedAction,
	} = props;

	return (
		<div style={{ flex: "1 1 0%", position: "relative" }}>
			{orders.length === 0 ? (
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						position: "absolute",
						left: "50%",
						top: "50%",
						transform: "translate(-50%, -50%)",
						gap: "5px",
					}}
				>
					<div className="no-order-icon"></div>

					<div
						className="typography-body-01 typography-bold"
						style={{ marginTop: "20px" }}
					>
						{statusFilterOption &&
						[
							OrderStatus.IN_PROGRESS,
							// OrderStatus.READY_TO_SHIP,
							OrderStatus.SHIPPED,
							OrderStatus.DELIVERED,
						].includes(statusFilterOption)
							? translation("NoOrdersHere")
							: translation("NoOrder")}
					</div>
					{statusFilterOption &&
					[
						OrderStatus.IN_PROGRESS,
						// OrderStatus.READY_TO_SHIP,
						OrderStatus.SHIPPED,
						OrderStatus.DELIVERED,
					].includes(statusFilterOption) ? (
						<></>
					) : (
						<>
							<div
								className="typography-body-02"
								style={{ color: NeutralColor.NEUTRAL_GREY_500 }}
							>
								{translation("NoOrderDescription")}
							</div>
							<div style={{ marginTop: "10px" }}>
								<BlueButton
									key="new-order-button"
									id="bew-order-button"
									children={
										<>
											<AddIcon /> {translation("NewOrder")}
										</>
									}
									onClick={() => {
										goToAddNewOrder();
									}}
								></BlueButton>
							</div>
						</>
					)}
				</div>
			) : (
				<ViewOrdersTable
					orders={orders}
					user={props.user}
					discardUnstartedOrder={discardUnstartedOrder}
					viewOrderCOC={viewOrderCOC}
					goToViewOrderDetails={goToViewOrderDetails}
					goToEditOrderPage={goToEditOrderPage}
					viewResult={viewResult}
					setDiscardOrderConfirmOpen={setDiscardOrderConfirmOpen}
					setProceedAction={setProceedAction}
				/>
			)}
		</div>
	);
}
